/**
 * 独立版购物车接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const bucketAlone = {
    //独立版修改商品购物车信息
    changeBucketNum(params) {
        const userLevelId = localStorage.getItem('userLevelId') || ''
        params.userLevelId = userLevelId
        return axios.post('/goods/mobileBucketAlone/changeBucketNum', qs.stringify(params));
    },
    //独立版获取所有购物车信息
    getBucketInfoAlone(params) {
        return axios.post('/goods/mobileBucketAlone/getBucketInfoAlone', qs.stringify(params));
    },
    //手机前台获取购物车数量（独立版）
    getBucketNumAlone(params) {
        return axios.post('/goods/mobileBucketAlone/getBucketNumAlone', qs.stringify(params));
    },
    //手机前台获取结算页面商品信息（独立版）
    getPayGoodsInfo(params) {
        return axios.post('/goods/mobileBucketAlone/getPayGoodsInfo', (params));
    },
    //手机前台删除组合套餐购物车信息（独立版）
    delPackageBucketInfo(params) {
        return axios.post('/goods/mobileBucketAlone/delPackageBucketInfo', qs.stringify(params));
    },
    //手机前台购物车获取满足商品促销活动信息（独立版）
    getMeetGoodsPromotion(params) {
        return axios.post('/goods/mobileBucketAlone/getMeetGoodsPromotion', qs.stringify(params));
    },
    //手机前台购物车获取满足品牌汇活动信息（独立版）
    getMeetBrandRemit(params) {
        return axios.post('/goods/mobileBucketAlone/getMeetBrandRemit', qs.stringify(params));
    },
    //手机前台结算页面获取所有赠送商品信息（独立版）
    getPayDonateGoodsInfo(params) {
        return axios.post('/goods/mobileBucketAlone/getPayDonateGoodsInfo', qs.stringify(params));
    },
    //获取结算页面所有可用优惠券信息列表
    getPayCouponAloneList(params) {
        return axios.post('/goods/mobileBucketAlone/getPayCouponAloneList', (params));
    },
    //独立版获取支付二维码信息
    getBwPayCodeUrlAlone(params) {
        return axios.post('/order/wzfPayAlone/getBwPayCodeUrlAlone', qs.stringify(params));
    },
    //独立版支付获取交易结果
    getPayResultAlone(params) {
        return axios.post('/order/wzfPayAlone/getPayResultAlone', qs.stringify(params));
    },
    //独立版获取所有已满足条件订单促销活动列表信息
    getAllMeetOrderPromotionInfo(params) {
        return axios.post('/goods/mobileBucketAlone/getAllMeetOrderPromotionInfo', qs.stringify(params));
    },
    //获取客户退货购物车信息
    getUserRefundBucketInfo(params) {
        return axios.post('/order/mobileRefundAlone/getUserRefundBucketInfo', qs.stringify(params));
    },
    //删除客户退货购物车信息
    delUserRefundBucketInfo(params) {
        return axios.post('/order/mobileRefundAlone/delUserRefundBucketInfo', qs.stringify(params));
    },
    //创建退货单信息
    createRefundOrderInfo(params) {
        return axios.post('/order/mobileRefundAlone/createRefundOrderInfo', params);
    },
    //满减活动
    checkFullReductionDiscountGiveActivityAloneInfo(params) {
        return axios.post('/goods/full/checkFullReductionDiscountGiveActivityAloneInfo', params);
    },
    //满减活动分仓
    checkFullReductionDiscountGiveActivityAloneInfoList(params) {
        return axios.post('/goods/full/checkFullReductionDiscountGiveActivityAloneInfoList', params);
    },
}

export default bucketAlone;


// WEBPACK FOOTER //
// ./src/request/api/bucket/bucket_alone.js